import { observable, computed, action } from 'mobx';
import dataSelectAdapter from 'adapters/DataSelectsAdapter';

class DataSelectStore {
  //TODO: refactor clearMaps logic
  selectItemsMap = {
  datatype: {
    clearMaps: ['clearTvs', 'clearAssetClasses', 'clearSubAssetClasses', 'clearInstruments', 'clearSegmentMics', 'clearOrderTypes'],
    loadMap: 'loadTvs',
    loadParams: ['datatype'],
    requiredParams: ['datatype'] // Add required params here
  },
  tv: {
    clearMaps: ['clearAssetClasses', 'clearSubAssetClasses', 'clearInstruments', 'clearSegmentMics', 'clearOrderTypes'],
    loadMap: 'loadAssetClasses',
    loadParams: ['datatype', 'tv'],
    requiredParams: ['datatype', 'tv'] // TV requires both 'datatype' and 'tv'
  },
  assetclass: {
    clearMaps: ['clearSubAssetClasses', 'clearInstruments', 'clearSegmentMics', 'clearOrderTypes'],
    loadMap: 'loadSubAssetClasses',
    loadParams: ['datatype', 'tv', 'assetclass'],
    requiredParams: ['datatype', 'tv'] // Required parameters for assetclass
  },
  subassetclass: {
    clearMaps: ['clearInstruments', 'clearSegmentMics', 'clearOrderTypes'],
    loadMap: 'loadInstruments',
    loadParams: ['datatype', 'tv', 'assetclass', 'subassetclass'],
    requiredParams: ['datatype', 'tv'] // Required params for subassetclass
  },
  instrument: {
    clearMaps: ['clearSegmentMics', 'clearOrderTypes'],
    loadMap: 'loadSegmentMics',
    loadParams: ['datatype', 'tv', 'assetclass', 'subassetclass', 'instrument'],
    requiredParams: ['datatype', 'tv'] // Required params for instrument
  },
  instrumentmic: {
    clearMaps: ['clearOrderTypes'],
    loadMap: 'loadOrderTypes',
    loadParams: ['datatype', 'tv', 'assetclass', 'subassetclass', 'instrument', 'instrumentmic'],
    requiredParams: ['datatype', 'tv'] // Required params for instrumentmic
  }
};

  @observable
  orderTradeMap = observable.map({
    order: {
      value: 'order',
      label: 'Orders'
    },
    trade: {
      value: 'trade',
      label: 'Trades'
    }
  });

  @observable tvsMap = observable.map();
  @observable assetClassesMap = observable.map();
  @observable subAssetClassesMap = observable.map();
  @observable instrumentsMap = observable.map();
  @observable segmentMicsMap = observable.map();
  @observable orderTypesMap = observable.map();

  isOrderTradeLoading = false;
  @observable isTvLoading = false;
  @observable isAssetClassesLoading = false;
  @observable isSubAssetClassesLoading = false;
  @observable isInstrumentsLoading = false;
  @observable areSegmentMicsLoading = false;
  @observable areOrderTypesLoading = false;
  @observable isSegmentMicLoadingFailed = false;

  @computed
  get orderTrades() {
    return this.orderTradeMap.values();
  }

  @computed
  get tvs() {
    return this.tvsMap.values();
  }

  @computed
  get assetClasses() {
    return this.assetClassesMap.values();
  }

  @computed
  get subAssetClasses() {
    return this.subAssetClassesMap.values();
  }

  @computed
  get instruments() {
    return this.instrumentsMap.values();
  }

  @computed
  get segmentMics() {
    return this.segmentMicsMap.values();
  }

  @computed
  get orderType() {
    return this.orderTypesMap.values();
  }

  @computed
  get orderTypeCount() {
    return this.orderType.length;
  }

  @computed
  get segmentMicsCount() {
    return this.segmentMics.length;
  }

  @action
  clearTvs() {
    this.tvsMap.clear();
  }

  @action
  clearAssetClasses() {
    this.assetClassesMap.clear();
  }

  @action
  clearSubAssetClasses() {
    this.subAssetClassesMap.clear();
  }

  @action
  clearInstruments() {
    this.instrumentsMap.clear();
  }

  @action
  clearSegmentMics() {
    this.segmentMicsMap.clear();
  }

  @action
  clearOrderTypes() {
    this.orderTypesMap.clear();
  }

  @action
  loadTvs(params) {
    this.isTvLoading = true;
    dataSelectAdapter
      .loadTVs(params)
      .then(
        action((results) => {
          this.fillMapFromArray(this.tvsMap, results);
          this.isTvLoading = false;
        })
      )
      .catch(() => {
        this.isTvLoading = false;
      });
  }

  @action
  loadAssetClasses(params) {
    this.isAssetClassesLoading = true;
    this.isSubAssetClassesLoading = true;
    this.isInstrumentsLoading = true;
    this.areOrderTypesLoading = true;
    this.areSegmentMicsLoading = true;
    return dataSelectAdapter.loadAssetClasses(params).then(
      action(({ assets, subassets, instrumentList, mic, ordertype }) => {
        this.fillMapFromArray(this.assetClassesMap, assets);
      // Remove commented code after testing
        if (subassets) {
          this.subassets = subassets;
          this.subassetsTimestamp = Date.now();
          this.fillMapFromArray(this.subAssetClassesMap, subassets);
        }

        if (instrumentList) {
          this.instrumentList = instrumentList;
          this.instrumentListTimestamp = Date.now();
          this.fillMapFromArray(this.instrumentsMap, instrumentList);
        }

        if (mic) {
          this.miclist = mic;
          this.miclistTimestamp = Date.now();
          this.fillMapFromArray(this.segmentMicsMap, mic);
        }

        if (ordertype) {
          this.ordertypelistTimestamp = Date.now();
          this.ordertypelist = ordertype;
        }

        this.isAssetClassesLoading = false;
        this.isSubAssetClassesLoading = false;
        this.isInstrumentsLoading = false;
        this.areOrderTypesLoading = false;
        this.areSegmentMicsLoading = false;
      })
    ).catch(
      action((error) => {
        console.error('Error loading asset classes:', error);
        this.isAssetClassesLoading = false;
        this.isSubAssetClassesLoading = false;
        this.isInstrumentsLoading = false;
        this.areOrderTypesLoading = false;
        this.areSegmentMicsLoading = false;
        this.clearTvs();
        this.loadTvs(params);
      })
    );
  }


  @action
  loadSubAssetClasses(params) {
    if (this.isSubAssetClassesLoading) {
       return;
    }
    const isCacheValid = this.subassets && this.subassetsTimestamp && (Date.now() - this.subassetsTimestamp < 500);
    this.isInstrumentsLoading = true;
    this.areOrderTypesLoading = true;
    this.isSubAssetClassesLoading = true;
    this.areSegmentMicsLoading = true;
    if (isCacheValid) {
      this.isSubAssetClassesLoading = false;
      this.isInstrumentsLoading = false;
      this.areOrderTypesLoading = false;
      this.areSegmentMicsLoading = false;
      this.fillMapFromArray(this.subAssetClassesMap, this.subassets);
      if (this.instrumentList) {
            this.fillMapFromArray(this.instrumentsMap, this.instrumentList);
      }
      if (this.ordertypelist) {
           this.fillMapFromArray(this.orderTypesMap, this.ordertypelist);
      }
      if (this.miclist) {
           this.fillMapFromArray(this.segmentMicsMap, this.miclist);
      }
    } else {
      dataSelectAdapter
        .loadSubAssetClasses(params)
        .then(
          action(({ subassets, instrumentList , mic, ordertype}) => {
            this.fillMapFromArray(this.subAssetClassesMap, subassets);
            if (instrumentList) {
              this.instrumentListTimestamp = Date.now();
              this.instrumentList = instrumentList;
              this.fillMapFromArray(this.instrumentsMap, instrumentList);
            }
            if (mic) {
              this.miclist = mic;
              this.miclistTimestamp = Date.now();
              this.fillMapFromArray(this.segmentMicsMap, this.miclist);
            }

            if (ordertype) {
              this.ordertypelistTimestamp = Date.now();
              this.ordertypelist = ordertype;
            }
            this.isSubAssetClassesLoading = false;
            this.isInstrumentsLoading = false;
            this.areOrderTypesLoading = false;
            this.areSegmentMicsLoading = false;
          })
        )
        .catch(() => {
          this.isSubAssetClassesLoading = false;
          this.isInstrumentsLoading = false;
          this.areOrderTypesLoading = false;
          this.areSegmentMicsLoading = false;
        });
    }
    this.subassets = null;
  }

  @action
  loadInstruments(params) {
    if (this.isInstrumentsLoading) {
      return;
    }
    this.isInstrumentsLoading = true;
    this.areOrderTypesLoading = true;
    this.areSegmentMicsLoading = true;
    const isCacheValid = this.instrumentList && this.instrumentListTimestamp && (Date.now() - this.instrumentListTimestamp < 500);
    if (isCacheValid) {
      this.isInstrumentsLoading = false;
      this.areOrderTypesLoading = false;
      this.areSegmentMicsLoading = false;
      this.fillMapFromArray(this.instrumentsMap, this.instrumentList);
      if (this.ordertypelist) {
         this.fillMapFromArray(this.orderTypesMap, this.ordertypelist);
      }
      if (this.miclist) {
         this.fillMapFromArray(this.segmentMicsMap, this.miclist);
      }
    }
    else {
      dataSelectAdapter
        .loadInstruments(params)
        .then(
          action(({instrumentList, mic, ordertype}) => {
            this.fillMapFromArray(this.instrumentsMap, instrumentList);

            if (mic) {
              this.miclist = mic;
              this.miclistTimestamp = Date.now();
              this.fillMapFromArray(this.segmentMicsMap, this.miclist);
            }

            if (ordertype) {
              this.ordertypelistTimestamp = Date.now();
              this.ordertypelist = ordertype;
            }

            this.isInstrumentsLoading = false;
            this.areOrderTypesLoading = false;
            this.areSegmentMicsLoading = false;
          })
        )
        .catch(() => {
          this.isInstrumentsLoading = false;
          this.areOrderTypesLoading = false;
          this.areSegmentMicsLoading = false;
        });
    }
    this.instrumentList = null;
  }


  @action
  loadSegmentMics(params) {
    if (this.areSegmentMicsLoading) {
      return;
    }
    this.areSegmentMicsLoading = true;
    this.isSegmentMicLoadingFailed = false;
    const isCacheValid = this.miclist && this.miclistTimestamp && (Date.now() - this.miclistTimestamp < 500);
    if (isCacheValid) {
      this.fillMapFromArray(this.segmentMicsMap, this.miclist);
      this.isSegmentMicLoadingFailed = false;
      this.areSegmentMicsLoading = false;
    } else {
      dataSelectAdapter
        .loadSegmentMics(params)
        .then(
          action((results = []) => {
            this.fillMapFromArray(this.segmentMicsMap, results);
            this.areSegmentMicsLoading = false;
            if (this.segmentMicsCount === 1) {
              const instrumentmic = results[0].value;
              this.loadOrderTypes({ ...params, instrumentmic });
            }
          })
        )
        .catch(() => {
          this.isSegmentMicLoadingFailed = true;
          this.areSegmentMicsLoading = false;
        });
    }
    this.miclist = null;
  }


  @action
  loadOrderTypes(params) {
    if (this.areOrderTypesLoading) {
      //this.areOrderTypesLoading = false;
      return;
    }
    this.areOrderTypesLoading = true;
    const isCacheValid = this.ordertypelist && this.ordertypelistTimestamp && (Date.now() - this.ordertypelistTimestamp < 500);
    if (isCacheValid) {
      this.fillMapFromArray(this.orderTypesMap, this.ordertypelist);
      this.areOrderTypesLoading = false;
    } else {
      dataSelectAdapter
        .loadOrderTypes(params)
        .then(
          action((results = []) => {
            this.fillMapFromArray(this.orderTypesMap, results);
            this.areOrderTypesLoading = false;
          })
        )
        .catch(err => {
          this.areOrderTypesLoading = false;
        });
    }
    this.ordertypelist = null;
  }

  @action
  onChangeSelect(value, name, values) {
    const itemMap = this.selectItemsMap[name];
    if (!itemMap) {
      return;
    }

    itemMap.clearMaps.forEach((itemClear) => {
      this[itemClear]();
    });
    const missingParams = itemMap.requiredParams.filter((param) => !values[param]);
    //

    if (missingParams.length === 0) {
      const params = {};
      itemMap.loadParams.forEach((paramName) => {
        params[paramName] = values[paramName];
      });
      this[itemMap.loadMap](params);
    } 
  }

  @action
  clearSelectData() {
    [
      this.tvsMap,
      this.assetClassesMap,
      this.subAssetClassesMap,
      this.instrumentsMap,
      this.segmentMicsMap,
      this.orderTypesMap
    ].forEach((m) => m.clear());
  }

  // helpers
  fillMapFromArray(map, array) {
    array.forEach(item => {
      map.set(item.value, item);
    });
  }

  @computed
  get isUpdating() {
    return [
        this.isOrderTradeLoading,
        this.isTvLoading,
        this.isAssetClassesLoading,
        this.isSubAssetClassesLoading,
        this.isInstrumentsLoading,
        this.areSegmentMicsLoading,
        this.areOrderTypesLoading
    ].reduce((prev, cur) => prev || cur);
  }
}

const dataSelectStore = new DataSelectStore();

export default dataSelectStore;



// WEBPACK FOOTER //
// ./src/stores/DataSelectStore.js